import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./CoinsPopup.css";

import coins from "../imagesHome/coins.png";
import coinImg from "../header/images/coin.png";

const formatCoins = (value) => Number(value || 0).toLocaleString("ro-RO");

const CoinsPopup = ({ coinCount, lessonCoinsEarned }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const totalCoins = Number(coinCount || 0);
  const hasLessonCoinsValue = lessonCoinsEarned !== undefined && lessonCoinsEarned !== null;
  const currentLessonCoins = Math.max(Number(lessonCoinsEarned || 0), 0);
  const topBarCoinsValue = hasLessonCoinsValue ? currentLessonCoins : totalCoins;
  const totalWithoutCurrentLesson = Math.max(totalCoins - currentLessonCoins, 0);

  const openPopup = () => {
    if (isVisible && isOpen) return;
    setIsVisible(true);
    requestAnimationFrame(() => setIsOpen(true));
  };

  const closePopup = () => {
    if (!isVisible) return;
    setIsOpen(false);
  };

  useEffect(() => {
    if (!isVisible) return;

    const closeTimer = setTimeout(() => {
      if (!isOpen) {
        setIsVisible(false);
      }
    }, 280);

    return () => clearTimeout(closeTimer);
  }, [isVisible, isOpen]);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("quiz-active");
      document.documentElement.classList.add("quiz-active");
    } else {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    }

    return () => {
      document.body.classList.remove("quiz-active");
      document.documentElement.classList.remove("quiz-active");
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isVisible) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [isVisible]);

  return (
    <div className="popup-question-container">
      <button
        type="button"
        className="oriented-question-track"
        onClick={isOpen ? closePopup : openPopup}
        aria-label="Deschide popup monede"
      >
        <img src={coins} className="coins-popup-icon" draggable={false} alt="Monede" />
        <div className="value-coins">{formatCoins(topBarCoinsValue)}</div>
      </button>

      {isVisible &&
        createPortal(
          <>
            <div className={`popup-question-overlay ${isOpen ? "open" : ""}`} onClick={closePopup} />
            <div
              className={`popup-question ${isOpen ? "open" : ""}`}
              role="dialog"
              aria-modal="true"
              aria-label="Detalii monede"
            >
              <button type="button" className="popup-question-close" onClick={closePopup}>×</button>
              <div className="popup-question-content">
                <div className="popup-question-coins-info">
                  <img src={coins} className="popup-coin-icon" draggable={false} alt="coins" />
                  <span>Sold monede</span>
                </div>

                <div className="coins-popup-summary">
                  <div className="coins-ledger-title">Registru monede</div>

                  <div className="coins-ledger-table" role="table" aria-label="Registru monede lecție">
                    <div className="coins-ledger-row" role="row">
                      <span className="coins-ledger-cell coins-ledger-label" role="cell">Sold precedent</span>
                      <span className="coins-ledger-cell coins-ledger-value" role="cell">
                        <img src={coinImg} className="coins-popup-sold" alt="coin" />
                        {formatCoins(totalWithoutCurrentLesson)}
                      </span>
                    </div>

                    <div className="coins-ledger-row" role="row">
                      <span className="coins-ledger-cell coins-ledger-label" role="cell">Intrari lectia curenta</span>
                      <span className="coins-ledger-cell coins-ledger-value" role="cell">
                        <img src={coinImg} className="coins-popup-sold" alt="coin" />
                        +{formatCoins(currentLessonCoins)}
                      </span>
                    </div>

                    <div className="coins-ledger-row coins-ledger-row-final" role="row">
                      <span className="coins-ledger-cell coins-ledger-label" role="cell">Sold final</span>
                      <span className="coins-ledger-cell coins-ledger-value" role="cell">
                        <img src={coinImg} className="coins-popup-sold" alt="coin" />
                        {formatCoins(totalCoins)}
                      </span>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </>,
          document.body
        )}
    </div>
  );
};

export default CoinsPopup;
